import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { DetailPolishOffRequest, OrderPolishOffRequest } from 'src/app/models/order.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { OrderService } from 'src/app/services/order.service';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent implements OnInit {
  showingOrder: { [key: number]: boolean } = {};
  showingCancel: { [key: number]: boolean } = {};
  showingHistory: { [key: number]: boolean } = {};
  showingHistoryDetail: { [key: number]: boolean } = {};
  filterWord: string = null;
  historyDetailShowed = null;
  orders = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  createOrder = false;
  createOrder2 = true;
  orderShowed = null;
  historyShowed = null;
  seeingAll = false;
  userId = null;
  isHistorical: boolean;
  getClimbOrders = false;

  constructor(
    private orderService: OrderService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private route: ActivatedRoute
  ) {
    this.userId = JSON.parse(authService.getCurrentUser()).id;
    var permissions = authService.getPermissions();
    if (permissions) {
      for (let i = 0; i < permissions.length; i++) {
        const element = permissions[i];
        if (element.roleId == 5017 && element.read) {
          this.seeingAll = true;
        } else if (element.roleId == 5040 && element.create) {
          this.getClimbOrders = true;
        }
      }
    }
    this.seeingAll = false;
  }

  ngOnInit(): void {
    this.isHistorical = this.route.snapshot.data.isHistorical;
    this.getOrders();
  }

  setOrders() {
    this.orders = this.orders.sort((a, b) => {
      return b.date - a.date
    });
    this.pagination.total = this.orders;
    this.resetPagination();
  }

  getOrders() {
    if (this.isHistorical) {
      if (this.getClimbOrders) {
        this.orderService.getClimbOrders().subscribe({
          next: (response: ResponseObject) => {
            var climbOrders = response.data;
            climbOrders.forEach((c) => {
              c.climb = true;
              this.orders.push(c);
            });
            this.setOrders();
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error(error.error.message);
          }
        })
      } else {
        this.showNormalOrders();
      }
    } else {
      this.showNormalOrders();
    }
  }

  showNormalOrders() {
    this.orderService.getOrders().subscribe({
      next: (response: ResponseObject) => {
        this.orders = response.data;
        if (!this.seeingAll && !this.isHistorical) {
          this.orders = this.orders.filter((u) => {
            return u.createdBy.id == this.userId
          })
        }
        if (this.getClimbOrders) {
          this.orderService.getClimbOrders().subscribe({
            next: (response: ResponseObject) => {
              var climbOrders = response.data;
              climbOrders.forEach((c) => {
                c.climb = true;
                this.orders.push(c);
              });
              this.setOrders();
            },
            error: (error: HttpErrorResponse) => {
              this.toastService.error(error.error.message);
            }
          })
        } else {
          this.setOrders();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  closeCreateOrder(created) {
    if (created) {
      this.getOrders();
    }
    this.createOrder = false;
  }

  closeCreateOrder2(created) {
    if (created) {
      this.getOrders();
    }
    this.createOrder2 = false;
    
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  showOrder(order: any) {
    if (this.showingOrder[order.id]) {
      return;
    }
    this.showingOrder[order.id] = true;
    this.orderService.getOrderDetail(order.id).subscribe({
      next: (response: ResponseObject) => {
        this.orderShowed = {};
        this.orderShowed['items'] = response.data;
        this.orderShowed['items'].forEach(element => {
          element['polishOff'] = 0;
        });
        this.orderShowed['items'].forEach(element => {
          element['provider'] = {
            value: null,
            verified: false,
            required: true,
            message: 'Campo requerido',
            class: 'fa-asterisk',
            color: 'danger',
            data: null,
            filterElements: []
          };
        });
        this.orderShowed['orderId'] = order.id;
        this.orderShowed['order'] = order;
        this.orderShowed['climb'] = order['climb'] ? true : false;
        this.showingOrder[order.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.showingOrder[order.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  confirmChanges() {
    if (this.showingOrder[this.orderShowed['orderId']]) {
      return;
    }
    this.showingOrder[this.orderShowed['orderId']] = true;
    var newPolishOff = new OrderPolishOffRequest();
    newPolishOff.date = (new Date()).getTime();
    newPolishOff.isCancelled = false;
    newPolishOff.orderId = this.orderShowed['orderId'];
    this.orderShowed.forEach(order => {
      newPolishOff.products.push(new DetailPolishOffRequest(order.id, order.productData.id, order['polishOff']));
    });
    this.orderService.polishOff(newPolishOff).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success(response.data);
        this.orderShowed = null;
        this.showingOrder[newPolishOff.orderId] = false;
        this.getOrders();
      },
      error: (error: HttpErrorResponse) => {
        this.showingOrder[newPolishOff.orderId] = false;
        this.toastService.error(error.error.message);
      }
    });
  }

  historyDetailOrder(order: any) {
    if (this.showingHistoryDetail[order.id]) {
      return;
    }
    this.showingHistoryDetail[order.id] = true;
    this.orderService.orderHistoryDetail(order.id).subscribe({
      next: (response: ResponseObject) => {
        this.historyDetailShowed = response.data;
        this.showingHistoryDetail[order.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.showingHistoryDetail[order.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  historyOrder(order: any) {
    if (this.showingHistory[order.id]) {
      return;
    }
    this.showingHistory[order.id] = true;
    this.orderService.orderHistory(order.id).subscribe({
      next: (response: ResponseObject) => {
        this.historyShowed = response.data;
        this.showingHistory[order.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.showingHistory[order.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  anulateOrder() {
    if (this.showingCancel[this.orderShowed['orderId']]) {
      return;
    }
    this.showingCancel[this.orderShowed['orderId']] = true;
    var newPolishOff = new OrderPolishOffRequest();
    newPolishOff.date = (new Date()).getTime();
    newPolishOff.isCancelled = true;
    newPolishOff.orderId = this.orderShowed['orderId'];
    this.orderShowed.forEach(order => {
      newPolishOff.products.push(new DetailPolishOffRequest(order.id, order.productData.id, order['polishOff']));
    });
    this.orderService.polishOff(newPolishOff).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success(response.data);
        this.orderShowed = null;
        this.getOrders();
        this.showingCancel[this.orderShowed['orderId']] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.showingCancel[this.orderShowed['orderId']] = false;
        this.toastService.error(error.error.message);
      }
    });
  }

  closePolishOff(created: boolean) {
    if (created) {
      this.getOrders();
    }
    this.orderShowed = null;
  }

  resetDeletingDiv() {
    this.orderShowed = null;
    this.historyShowed = null;
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  searching() {
    this.pagination.total = this.orders.filter((order) => {
      return order.id + '' == this.filterWord || order.warehouse.name.toLowerCase().includes(this.filterWord.toLowerCase()) || order.createdBy.email.toLowerCase().includes(this.filterWord.toLowerCase())
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }
}
